import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=7a0bc452"
import script from "./CourseIndex.vue?vue&type=script&lang=js"
export * from "./CourseIndex.vue?vue&type=script&lang=js"
import style0 from "./CourseIndex.vue?vue&type=style&index=0&id=7a0bc452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports